export enum TeamUserRole {
    AdminOnly = '00000000-0000-0000-0000-000000000001',
    MemberOnly = '00000000-0000-0000-0000-000000000002',
    AdminAndMember = '00000000-0000-0000-0000-000000000003'
}